import { APIS } from '@/constants';
import axios from 'axios';

const userApi = {
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestDetail(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      method: 'get',
      baseURL: APIS.BASE_URL.USER,
      headers,
    });
  },
};

export default userApi;
